import React, { useState } from 'react';
import '../scss/TyreLabel.scss';

const FUEL_CONSUMPTION = {
  'A': { text: 'Pneu très économique. Pas d\'impact sur la consommation de carburant', color: '#00aa4f' },
  'B': { text: 'Pneu économique à consommation de carburant réduite', color: '#95cb45' },
  'C': { text: 'Pneu à impact limité sur la consommation de carburant', color: '#ffea3d' },
  'D': { text: 'Consommation de carburant augmentée', color: '#ffb52f' },
  'E': { text: 'Impact conséquent consommation de carburant', color: '#ff2d16' }
};

const WET_GRIP = {
  'A': { text: 'Excellent freinage sur le mouillé.', color: '#0064b6' },
  'B': { text: 'Très bon freinage sur le mouillé', color: '#0c85ca' },
  'C': { text: 'Bon freinage sur le mouillé', color: '#49b0e1' },
  'D': { text: 'Freinage moyen sur le mouillé', color: '#71c9ed' },
  'E': { text: 'Mauvaise performances de freinage sur le mouillé', color: '#a9e8fa' }
};

const REINFORCED = {
  'XL': 'Extra Load = Pneu renforcé (indice de charge supérieur)',
  'RF': 'Reinforced = Pneu renforcé (indice de charge supérieur)',
  'RFD': 'Reinforced = Pneu renforcé (indice de charge supérieur)'
};

export const SEASON = {
  'ETE': 'Été',
  'HIVER': 'Hiver',
  'TOUTE SAISON': '4 saisons'
};

const SPECIAL_FEATURES = {
  'crm': {
    label: 'ContiRe.Tex™',
    text: 'Technologie Continental, composition du pneu à partir de matériaux 100% recyclés ou durables'
  },
  'continentalSeal': {
    label: 'ContiSeal™',
    text: 'Technologie Continental, colmate immédiatement les crevaisons'
  },
  'continentalSilent': {
    label: 'ContiSilent™',
    text: 'Technologie Continental, réduit les composants sonores du bruit de roulement'
  },
  'ev': {
    label: 'EV',
    text: 'Conception adaptée aux véhicules électriques'
  },
  'R-F': {
    label: 'RunFlat',
    text: 'Pneu RunFlat, permet de rouler jusqu\'à 80 km après une crevaison'
  },
  'ROF': {
    label: 'RunFlat',
    text: 'Pneu RunFlat, permet de rouler jusqu\'à 80 km après une crevaison'
  },
  'SSR': {
    label: 'SSR',
    text: 'Self-Supporting Runflat, permet de rouler jusqu\'à 80 km après une crevaison'
  },
  'RNF': {
    label: 'RunFlat',
    text: 'Pneu RunFlat, permet de rouler jusqu\'à 80 km après une crevaison'
  },
  'ZP': {
    label: 'ZP',
    text: 'Zero Pressure, permet de rouler jusqu\'à 80 km après une crevaison'
  },
  'EMT': {
    label: 'EMT',
    text: 'Extended Mobility Technology, permet de rouler jusqu\'à 80 km après une crevaison'
  }
};

export const TyreLabel = ({ type, value }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  let isSeason = false;
  const getLabelInfo = () => {
    switch (type) {
		case 'fuel':
			return { ...FUEL_CONSUMPTION[value], icon: '/wp-content/plugins/ax_tyres_catalog/app/public/svg/fuel.svg' };
		case 'grip':
			return { ...WET_GRIP[value], icon: '/wp-content/plugins/ax_tyres_catalog/app/public/svg/grip.svg' };
		case 'sound':
			return { text: 'Bruit de roulement extérieur mesuré en décibel', icon: '/wp-content/plugins/ax_tyres_catalog/app/public/svg/noise.svg' };
		case 'reinforced':
			return { text: REINFORCED[value] };
		case 'TOUTE SAISON':
			isSeason = true;
			return { text: '', icon: '/wp-content/plugins/ax_tyres_catalog/app/public/svg/season.svg' };
		case 'ETE':
			isSeason = true;
			return { text: '', icon: '/wp-content/plugins/ax_tyres_catalog/app/public/svg/ete.svg' };
		case 'HIVER':
			isSeason = true;
			return { text: '', icon: '/wp-content/plugins/ax_tyres_catalog/app/public/svg/hiver.svg' };
		case 'feature':
			return SPECIAL_FEATURES[value];
		default:
			return null;
    }
  };

  const labelInfo = getLabelInfo();
  if (!labelInfo) return null;

  return (
    <div 
      className={"tyre-label " + type + (isSeason ? ' season' : '')}
      data-type={type}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
	  <div className="label-icon-wrapper">
		{labelInfo.icon && (
			<img src={labelInfo.icon} alt="" className="label-icon" />
		)}
		<span 
			className="label-value" data-color={labelInfo.color}
			style={{ 
				backgroundColor: labelInfo.color,
				'--arrow-color': labelInfo.color 
			}}
		>
			{type === 'feature' ? labelInfo.label : value}
		</span>
	  </div>
	  {labelInfo.text && (
		<div className="label-tyre-info d-none">
          {labelInfo.text}
		</div>
	  )}
      {showTooltip && labelInfo.text !== '' && (
        <div className="label-tooltip">
          {labelInfo.text}
        </div>
      )}
    </div>
  );
};

export const ApprovalBadge = ({ label }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const getApprovalInfo = () => {
    const approvals = {
        'AM2': 'Pneu monté d\'origine sur Aston Martin, non adapté à tout autre type de véhicule',
        'AM4': 'Pneu monté d\'origine sur Aston Martin, non adapté à tout autre type de véhicule',
        'AM6': 'Pneu monté d\'origine sur Aston Martin, non adapté à tout autre type de véhicule',
        'AM8': 'Pneu monté d\'origine sur Aston Martin, non adapté à tout autre type de véhicule',
        'AM9': 'Pneu monté d\'origine sur Aston Martin, non adapté à tout autre type de véhicule',
        'AMR': 'Pneu monté d\'origine sur Aston Martin, non adapté à tout autre type de véhicule',
        'AMS': 'Pneu monté d\'origine sur Aston Martin, non adapté à tout autre type de véhicule',
        'AMV': 'Pneu monté d\'origine sur Aston Martin, non adapté à tout autre type de véhicule',
        'AO1': 'Pneu monté d\'origine sur Audi, adapté à tout autre type de véhicule',
        'AOE': 'Pneu monté d\'origine sur Audi, adapté à tout autre type de véhicule',
        'AOMO': 'Pneu monté d\'origine sur Audi/Mercedes, adapté à tout autre type de véhicule',
        'AOS1': 'Pneu monté d\'origine sur Audi, adapté à tout autre type de véhicule',
        'B': 'Pneu monté d\'origine sur Bentley, non adapté à tout autre type de véhicule',
        'B1': 'Pneu monté d\'origine sur Bentley, non adapté à tout autre type de véhicule',
        'BMW': 'Pneu monté d\'origine sur BMW, adapté à tout autre type de véhicule',
        'BMW/MO': 'Pneu monté d\'origine sur BMW/Mercedes, adapté à tout autre type de véhicule',
        'BMW/MOE': 'Pneu monté d\'origine sur BMW/Mercedes, adapté à tout autre type de véhicule',
        'F': 'Pneu monté d\'origine sur Ferrari, non adapté à tout autre type de véhicule',
        'FO': 'Pneu monté d\'origine sur Ferrari, non adapté à tout autre type de véhicule',
        'G1': 'Marquage Michelin, montage par 2 par essieu impératif',
        'HO': 'Pneu monté d\'origine sur Honda, adapté à tout autre type de véhicule',
        'J': 'Pneu monté d\'origine sur Jaguar, adapté à tout autre type de véhicule',
        'JRS': 'Pneu monté d\'origine sur Jaguar, non adapté à tout autre type de véhicule',
        'K1': 'Pneu monté d\'origine sur Ferrari, non adapté à tout autre type de véhicule',
        'K2': 'Pneu monté d\'origine sur Ferrari, non adapté à tout autre type de véhicule',
        'L': 'Pneu monté d\'origine sur Mac Laren, non adapté à tout autre type de véhicule',
        'MC1': 'Pneu monté d\'origine sur Lamborghini, non adapté à tout autre type de véhicule',
        'MGT': 'Pneu monté d\'origine sur Maserati, adapté à tout autre type de véhicule',
        'MO': 'Pneu monté d\'origine sur Mercedes, adapté à tout autre type de véhicule',
        'MOE': 'Pneu monté d\'origine sur Mercedes, adapté à tout autre type de véhicule',
        'N0': 'Pneu monté d\'origine sur Porsche, adapté à tout autre type de véhicule',
        'N1': 'Pneu monté d\'origine sur Porsche, adapté à tout autre type de véhicule',
        'N2': 'Pneu monté d\'origine sur Porsche, adapté à tout autre type de véhicule',
        'N3': 'Pneu monté d\'origine sur Porsche, adapté à tout autre type de véhicule',
        'N4': 'Pneu monté d\'origine sur Porsche, adapté à tout autre type de véhicule',
        'PE': 'Pneu monté d\'origine sur Peugeot, adapté à tout autre type de véhicule',
        'RO1': 'Pneu monté d\'origine sur Audi Quattro, adapté à tout autre type de véhicule',
        'RO2': 'Pneu monté d\'origine sur Audi Quattro, adapté à tout autre type de véhicule',
        'TPC': 'Pneu monté d\'origine sur Cadillac, non adapté à tout autre type de véhicule',
        'VW': 'Pneu monté d\'origine sur VW, adapté à tout autre type de véhicule',
        'TO': 'Pneu monté d\'origine sur Tesla, adapté à tout autre type de véhicule',
        'VOL': 'Pneu monté d\'origine sur Volvo, adapté à tout autre type de véhicule',
    };
    return approvals[label];
  };

  const approvalInfo = getApprovalInfo();
  if (!approvalInfo) return null;

  return (
    <div 
      className="approval-badge"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <span className="badge-value">{label}</span>
      {showTooltip && (
        <div className="badge-tooltip">
          {approvalInfo}
        </div>
      )}
    </div>
  );
}; 